"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectedUserContext = exports.useSelectedUser = exports.SelectedUserProvider = void 0;
const react_1 = __importStar(require("react"));
const zustand_1 = require("zustand");
const helper_1 = require("./helper");
const createSelectedUserStore = (initProps) => {
    const defaultProps = {
        selectAll: false,
        include: [],
        exclude: []
    };
    return (0, zustand_1.createStore)()((set, get) => (Object.assign(Object.assign(Object.assign({}, defaultProps), initProps), { setSelectedUser: ({ selectAll, include, exclude }) => {
            return (0, helper_1.setSelectedUser)(set, selectAll, include, exclude);
        }, selectAllCheckbox: ({ filter, allIds, totalUsers }) => {
            return (0, helper_1.selectAllCheckbox)(get, set, filter, allIds, totalUsers);
        }, selectUser: (selectedId) => (0, helper_1.selectUser)(get, set, selectedId), resetSelectedUser: () => {
            return set(defaultProps);
        }, isAllSelected: ({ allIds, totalUsers, filter }) => {
            return (0, helper_1.isAllSelected)(get, allIds, totalUsers, filter);
        }, isSelected: (selectedId) => (0, helper_1.isSelected)(get, selectedId) })));
};
const SelectedUserContext = (0, react_1.createContext)(null);
exports.SelectedUserContext = SelectedUserContext;
function SelectedUserProvider({ children, initialValue }) {
    const storeRef = (0, react_1.useRef)();
    if (!storeRef.current) {
        storeRef.current = createSelectedUserStore(Object.assign({}, initialValue));
    }
    return (react_1.default.createElement(SelectedUserContext.Provider, { value: storeRef.current }, children));
}
exports.SelectedUserProvider = SelectedUserProvider;
function useSelectedUser(selector, equalityFn) {
    const store = (0, react_1.useContext)(SelectedUserContext);
    if (!store)
        throw new Error('Missing SelectedUserProvider in the tree');
    return (0, zustand_1.useStore)(store, selector, equalityFn);
}
exports.useSelectedUser = useSelectedUser;
